export const SuccessDealStageType = 'system_success'
export const FailDealStageType = 'system_fail'
export const CustomDealStageType = 'custom'

export type DealStageType = typeof CustomDealStageType | typeof SuccessDealStageType | typeof FailDealStageType

export type DealTimelineData = DealTimelineComment | DealTimelineCreated | DealTimelineFieldUpdated

export enum DealTimelineType {
  comment = 'comment',
  created = 'created',
  fieldUpdated = 'field_updated',
}

export enum DealTimelineFilters {
  entityType = 'entityType',
}

export type DealTimelineComment = {
  type: DealTimelineType.comment
  comment: string
}

export type DealTimelineCreated = {
  type: DealTimelineType.created
}

export type DealTimelineFieldUpdated = {
  type: DealTimelineType.fieldUpdated
  stage: {
    oldValue: number
    newValue: number
  }
}
